import * as React from "react";
const SvgFiRrCircleG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-g_svg__a)">
      <path
        fill="#062147"
        d="M12.04.019c-6.618 0-12 5.383-12 12s5.382 12 12 12c6.616 0 12-5.384 12-12s-5.385-12-12-12m0 22c-5.515 0-10-4.486-10-10s4.484-10 10-10c5.514 0 10 4.486 10 10s-4.487 10-10 10m4.63-9.131c.376.53.471 1.184.258 1.789-.72 2.048-2.822 3.592-4.889 3.592-2.757 0-5-2.243-5-5v-2.5c0-2.757 2.243-5 5-5 1.434 0 2.8.617 3.75 1.693a1.001 1.001 0 0 1-1.5 1.324 3 3 0 0 0-2.25-1.016c-1.654 0-3 1.346-3 3v2.5c0 1.654 1.346 3 3 3 1.218 0 2.565-1.012 3.002-2.255l-2.002.005a1 1 0 1 1 0-2h1.953c.665 0 1.292.325 1.678.869z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-g_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleG;
